import { TagBox } from 'devextreme-react';
import DataGrid, {
    Column,
    Export,
    FilterRow,
    Grouping,
    GroupPanel,
    Pager,
    Paging,
    Scrolling,
    Selection
} from 'devextreme-react/data-grid';
import DropDownBox from 'devextreme-react/drop-down-box';
import RadioGroup from 'devextreme-react/radio-group';
import ScrollView from 'devextreme-react/scroll-view';
import React, { useState } from 'react';
import 'react-perfect-scrollbar/dist/css/styles.css';
import { toast } from 'react-toastify';
import { Button, Col, Row } from 'reactstrap';
import { onExporting } from '../../../../utils/DataGridExporter';
import useFormatMessage from '../../../../utils/useFormatMessage';

export default function PermissionTab({ roleGroups, selectedRowKeys, selectedUserRoles, setSelectedRowKeys, permissionGroupDatas, toggle, selectedPermissionGroup, setSelectedPermissionGroup, selectedUsers, setSelectedUsers, userDatas, isPermissionModal, isEmployeeAddModal, isUpdateModal, isEmployeeUpdateModal }) {
    const pageSizes = [10, 25, 50, 100];
    const [radioGroupVal, setRadioGroupVal] = useState(null)
    const notifyWarn = (message) => toast.warn(`${message}`);
    const { t } = useFormatMessage();

    function tableRender() {
        return (
            <ScrollView id="scrollview"
                // reachBottomText="Güncelleniyor..."
                scrollByContent={true}
                bounceEnabled={true}
                showScrollbar={true}
                scrollByThumb={true}>
                <DataGrid
                    dataSource={userDatas}
                    //   hoverStateEnabled={true}
                    onSelectionChanged={(e) => {
                        if (e.selectedRowKeys.length) {
                            const idHolder = []
                            e.selectedRowsData.forEach((user) => {
                                idHolder.push(user.employee_id)
                            })
                            setSelectedUsers(idHolder)
                        }
                    }}
                >
                    <Column dataField="full_name" alignment="center" allowSorting={true} caption="Kullanıcı" />
                    <Selection mode="multiple" />
                    <Scrolling mode="virtual" />
                    <Paging enabled={true} pageSize={10} />
                    <FilterRow visible={true} />

                </DataGrid>
            </ScrollView>
        )
    }
    const roleItems = [
        // { id: 0, text: 'Full Yazma Yekisi', value: "write" },
        { id: 1, text: 'Sadece Görme Yetkisi', value: "read" },
        { id: 2, text: 'Sadece Ekleme Yetkisi', value: "add" },
        { id: 3, text: 'Sadece Güncelleme Yetkisi', value: "update" },
        { id: 4, text: 'Sadece Silme Yetkisi', value: "delete" },
        { id: 5, text: 'Sadece Excel Export Yetkisi', value: "excel" },
        { id: 6, text: 'Tüm Özel Rolleri Kaldır', value: "" }
    ];

    function currentlySelected(selections) {
        setSelectedRowKeys(selections)
    }

    function typeOnChange(value) {
        const filterRoleGroups = []
        if (value === "read") {
            roleGroups.Datas.forEach((role) => {
                if (role.access_type === "READ")
                    filterRoleGroups.push(role.role_id)

            })
        } else if (value === "write") {

            roleGroups.Datas.forEach((role) => {
                if (role.access_type === "WRITE")
                    filterRoleGroups.push(role.role_id)

            })
        } else if (value === "add") {
            roleGroups.Datas.forEach((role) => {
                if (role.access_type === "ADD")
                    filterRoleGroups.push(role.role_id)

            })
        } else if (value === "delete") {
            roleGroups.Datas.forEach((role) => {
                if (role.access_type === "DELETE")
                    filterRoleGroups.push(role.role_id)

            })
        } else if (value === "update") {
            roleGroups.Datas.forEach((role) => {
                if (role.access_type === "UPDATE")
                    filterRoleGroups.push(role.role_id)

            })
        } else if (value === "excel") {
            roleGroups.Datas.forEach((role) => {
                if (role.access_type === "EXCEL")
                    filterRoleGroups.push(role.role_id)

            })
        }

        else if (value === "") {
            filterRoleGroups.push()
        }
        setSelectedRowKeys(filterRoleGroups)
        setRadioGroupVal(value)
    }

    const onEditorPreparing = (e) => {
        if (e.type !== 'selection') return;
        if (e.row?.data) {
            let result = selectedUserRoles?.some(role => role.RoleId === e.row?.data.role_id)
            if (result) {
                e.editorOptions.disabled = true;
            }
        }
    }

    function changeRoles(e) {
        if (e.includes(10) && e.length > 1) {
            notifyWarn(t("Super Admin en kapsamlı roldür. Ek role ihtiyaç yok."))
            setSelectedPermissionGroup([10]);
        } else {
            setSelectedPermissionGroup(e)
        }
    }


    return (
        <Row>
            <Col>
                <Row>
                    <Col lg="12">
                        <div className="dx-fieldset">
                            {
                                isUpdateModal === true &&
                                <>
                                    <Row>
                                        <Col xl="12" className='mb-4'>
                                            <h5>{t("Kullanıcı Bilgileri")}</h5>
                                        </Col>
                                    </Row>
                                    <div className="dx-field mb-3 ml-2">
                                        <div className="dx-field-label" style={{ color: "black" }}>{t("Kullanıcı Adı")}</div>
                                        <div className="dx-field-value">
                                            <div id="username_div">-</div>
                                        </div>
                                    </div>
                                </>
                            }
                            {/* <Row>
                                <Col xl="12" className='mb-4'>
                                    <h5>Yetki Grupları</h5>
                                </Col>
                            </Row> */}
                            <Row>
                                <div xl="12" className='mb-3' style={{ width: "750px", opacity: "0.6", backgroundColor: "#1DB2F5", borderRadius: "15px", padding: "5px", marginTop: "10px" }}>
                                    <div style={{ fontSize: "15px", color: 'white', textAlign: "center", verticalAlign: "center" }}>{t("Yetki Grupları")}</div>
                                </div>
                            </Row>
                            <div className="dx-field mb-3">
                                <div className="dx-field-label" style={{ color: "black" }}>{t("Yetki Grubu Adı")}</div>
                                <div className="dx-field-value">
                                    <TagBox
                                        id="PermissionGroupSelect"
                                        dataSource={permissionGroupDatas.permission_groups}
                                        value={selectedPermissionGroup}
                                        valueExpr="permission_group_id"
                                        displayExpr={"permission_group_name"}
                                        maxDisplayedTags={3}
                                        showMultiTagOnly={false}
                                        searchEnabled={true}
                                        onValueChange={(e) => {
                                            changeRoles(e)
                                        }}
                                    />
                                </div>
                            </div>
                            {isPermissionModal === true &&
                                <>
                                    <Row>
                                        <Col xl="12" className='mb-4'>
                                            <h5>{t("Kullanıcı Bilgileri")}</h5>
                                        </Col>
                                    </Row>
                                    <div className="dx-field mb-3">
                                        <div className="dx-field-label" style={{ color: "black" }}>{t("Kullanıcı Adı")}</div>
                                        <div className="dx-field-value">
                                            <DropDownBox
                                                value={selectedUsers}
                                                valueExpr="employee_id"
                                                deferRendering={false}
                                                displayExpr="full_name"
                                                placeholder={t("Lütfen Kullanıcı seçiniz") + "..."}
                                                showClearButton={false}
                                                dataSource={userDatas}
                                                onValueChanged={(e) => {
                                                    if (e.value === null) {
                                                        setSelectedUsers([])
                                                    } else {
                                                        setSelectedUsers(e.value)
                                                    }
                                                }}
                                                contentRender={tableRender}
                                            />
                                        </div>
                                    </div>
                                </>
                            }
                            <Row>

                                <Col xl="12" md="2" className='mb-4 ' style={{ width: "100px", opacity: "0.6", backgroundColor: "#1DB2F5", borderRadius: "15px", padding: "5px", marginTop: "10px" }}>

                                    <div style={{ fontSize: "15px", color: 'white', textAlign: "center", verticalAlign: "center" }}>{t("Özel Roller")}</div>

                                </Col>
                                <Row>
                                    <div className="option mb-4">
                                        <RadioGroup
                                            layout="horizontal"
                                            items={roleItems}
                                            value={radioGroupVal}
                                            itemRender={(item) => {
                                                return (
                                                    <>
                                                        {t(item.text)}
                                                    </>
                                                );
                                            }}
                                            valueExpr="value"
                                            displayExpr="text"
                                            onValueChanged={(e) => {
                                                typeOnChange(e.value)
                                            }}
                                        />

                                    </div>
                                </Row>
                                <Row>
                                    <Col>
                                        <span style={{ color: "red" }}>{t("marked_roles")}</span> &nbsp;
                                        <span style={{ color: "red", fontWeight: "bold" }}>{t("in_selected_role_group")}</span>&nbsp;
                                        <span style={{ color: "red" }}>{t("defined_roles")}</span>&nbsp;
                                        <span style={{ color: "red", fontWeight: "bold" }}>{t("special_role")}</span>&nbsp;
                                        <span style={{ color: "red" }}>{t("as_special_role")}</span>
                                    </Col>
                                </Row>
                                <DataGrid
                                    className='datagrid gridContainer-style'
                                    dataSource={roleGroups.Datas !== undefined ? roleGroups.Datas : roleGroups}
                                    showBorders={true}
                                    onSelectedRowKeysChange={currentlySelected}
                                    selectedRowKeys={selectedRowKeys}
                                    allowColumnResizing={true}
                                    key="role_id"
                                    keyExpr="role_id"
                                    onExporting={onExporting}
                                    onEditorPreparing={onEditorPreparing}
                                    groupPanel={{
                                        visible: true,
                                        emptyPanelText: t("Gruplamak için sütun başlığını buraya sürükleyin"),
                                        allowColumnDragging: true,
                                        showWhenGrouped: true,
                                        texts: {
                                            groupByThisColumn: t("Bu sütuna göre grupla"),
                                            groupContinuedMessage: t("Devamı için buraya tıklayın"),
                                            groupContinuesMessage: t("Devamı için buraya tıklayın"),
                                            ungroup: t("Grubu çöz"),
                                            ungroupAll: t("Tüm grupları çöz"),
                                            ungroupRow: t("Grubu çöz"),
                                        }
                                    }}

                                >
                                    <Export enabled={true} />
                                    <FilterRow visible={true} />
                                    <GroupPanel visible={true} />
                                    <Grouping autoExpandAll={false}

                                    />
                                    <Selection
                                        mode="multiple"
                                        allowSelectAll={false} />
                                    <Column dataField="role_group_description" selectedFilterOperation={"contains"} caption={t("Yetki Grubu Adı")} alignment="center" groupIndex={0} />
                                    <Column dataField="role_description" selectedFilterOperation={"contains"} caption={t("Rol Adı")} alignment="center" />
                                    <Pager allowedPageSizes={pageSizes} showPageSizeSelector={true} />
                                    <Paging defaultPageSize={10} />

                                </DataGrid>
                            </Row>

                        </div>
                    </Col>
                </Row>
                {
                    (isEmployeeAddModal === true || isEmployeeUpdateModal === true) &&
                    <Row>
                        <Col md="6">
                            <Button id='backButton' style={{ float: "left" }} onClick={() => { toggle('2'); }} >{t("Geri")}</Button>
                        </Col>
                        {/* <Col md="6">
                            <Button style={{ float: "right" }} onClick={() => { toggle('4'); }} >İleri</Button>
                        </Col> */}
                    </Row>
                }

                <Row>
                    {/* <Col md="12">
                        <Button style={{ float: "right" }} onClick={() => { toggle('3'); }} >{t("İleri")}</Button>
                    </Col> */}
                </Row>

            </Col >
        </Row >
    )
}